// Omnix/common/schemas/collections/omniTickets.js
import { z } from "zod";

const OmniTicketSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this ticket belongs to."),
    
    ticketNumber: z.number().int().positive().describe("User-friendly, sequential ticket ID."),
    subject: z.string().min(1, "Subject is required."),
    
    status: z.enum(['new', 'open', 'pending', 'solved', 'closed']).default('new'),
    priority: z.enum(['low', 'normal', 'high', 'urgent']).default('normal'),
    
    contactId: z.string().describe("The primary contact associated with this ticket."),
    assigneeId: z.string().optional().nullable().describe("The userId of the agent assigned to this ticket."),
    
    linkedConversationIds: z.array(z.string()).default([]).describe("Array of conversation _ids linked to this ticket."),
    
    // Configuration for automated responses for this specific ticket
    autoResponseConfig: z.object({
        onStatusChange: z.boolean().default(true),
        onAssignment: z.boolean().default(true),
    }).default({ onStatusChange: true, onAssignment: true }),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniTicketSchema;